import { useState } from "react";
import { useUserContext } from "../useUserContext";
import { authenticatedFetch } from "@/app/_utils/authenticatedFetch";
const useIntegrateQuickbooks = () => {
  const user = useUserContext();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<null | string>(null);
  const [data, setData] = useState<null | { data: string }>(null);

  const integrateQuickbooks = async () => {
    setIsLoading(true);
    setError(null);
    setData(null);

    try {
      const response = await authenticatedFetch("/api/quickbooks/auth", {
        method: "POST",
        // technically not needed but just in case lolz
        body: JSON.stringify({ userId: user.uid }),
      });
      const responseData = await response.json();
      setData(responseData);
    } catch (error: any) {
      setIsLoading(false);
      setError(error);
    }
  };

  return { isLoading, error, data, integrateQuickbooks };
};

export default useIntegrateQuickbooks;
